// Newest first. Dates are 'YYYY-MM-DD'; the profile menu shows a dot for entries newer than the last time the drawer was opened.
export const RELEASE_NOTES = [
  {
    date: "2026-10-26",
    title: "Weekly timesheets",
    body: "Type hours straight into the week, start from what Schedule booked, then submit for approval. Managers approve or send back from the Team table.",
  },
  {
    date: "2026-10-19",
    title: "Schedule as a grid",
    body: "Leave, capacity and double-bookings show in one grid, with batch changes and a list view.",
  },
  {
    date: "2026-10-12",
    title: "Sign-up and onboarding",
    body: "Guided sign-up with an email code, company defaults, team invites and a free trial.",
  },
];
